<template>
  <div>
    <template v-if="!nucleusUser()">
      <h1 class="page-header">No Access</h1>
      You do not have access to this page. Please contact HIA.
    </template>
    <div v-else id="editReviewRequest">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <clientNavSelector></clientNavSelector>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: `/${currentClientId}/requests` }">Requests</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: `/${currentClientId}/requests/review-request/`+$route.params.id }">Edit Review
        Schedule Request
      </el-breadcrumb-item>
    </el-breadcrumb>
    <hia-loading v-if="loading"></hia-loading>

    <div v-if="!loading">
      <h4 class="heading">Set Location, Review Description and Notes
      </h4>
      <el-form v-loading="editLoading" element-loading-spinner="nucleus-loader" class="editForm" label-position="top" ref="reviewRequest" :rules="rules" :model="reviewRequest"
        @submit.prevent.native>
        <el-form-item v-if="reviewRequest.reviewType && reviewRequest.reviewType.some(x => x === 'Acute')" prop="acuteReviewTypeId" label="Acute Review Type">
          <el-select v-model="reviewRequest.acuteReviewTypeId" size="mini" @change="editReviewRequest()">
            <el-option v-for="(item, index) in reviewTypes.filter(x => x.serviceLine === 'Acute')" :value="item.reviewTypeId" :label="item.type" :key="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="reviewRequest.reviewType && reviewRequest.reviewType.some(x => x === 'Professional Fee')" prop="proReviewTypeId" label="Professional Fee Review Type">
          <el-select v-model="reviewRequest.proReviewTypeId" size="mini" @change="editReviewRequest()">
            <el-option v-for="(item, index) in reviewTypes.filter(x => x.serviceLine === 'Pro')" :value="item.reviewTypeId" :label="item.type" :key="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="reviewRequest.reviewType && reviewRequest.reviewType.some(x => x === 'Ambulatory')" prop="ambulatoryReviewTypeId" label="Ambulatory Review Type">
          <el-select v-model="reviewRequest.ambulatoryReviewTypeId" size="mini" @change="editReviewRequest()">
            <el-option v-for="(item, index) in reviewTypes.filter(x => x.serviceLine === 'Ambulatory')" :value="item.reviewTypeId" :label="item.type" :key="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="reviewDescription" label="Review Objective">
          <el-input type="textarea" :rows="3" class="reviewDescription" placeholder="Explain objectives of review" v-model="reviewRequest.reviewDescription"
            @change="editReviewRequest()">
          </el-input>
        </el-form-item>
        <el-form-item prop="dateRangeDisplay" label="Requested Review Dates">
          <el-date-picker v-model="reviewRequest.dateRangeDisplay" type="daterange" range-separator="To" start-placeholder="Start date" end-placeholder="End date"
            format="MM/dd/yyyy" value-format="MM/dd/yyyy" @change="editReviewRequest()">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="Notes">
          <el-input class="notes" type="textarea" :rows="4" placeholder="Notes" v-model="reviewRequest.notes" @change="editReviewRequest()">
          </el-input>
        </el-form-item>
      </el-form>
      <ReviewRequestAcuteRecordDetails ref="reviewRecordDetails" :loading="recordLoading" :reviewRequest="reviewRequest" @toggleProSelectedBy="toggleProSelectedBy"
        @addRecords="editRecords" @addProRecords="editProRecords" @addAmbulatoryRecords="editAmbulatoryRecords" @clearRecords="clearRecords" @clearProRecords="clearProRecords"
        @clearAmbulatoryRecords="clearAmbulatoryRecords">
      </ReviewRequestAcuteRecordDetails>
    </div>
    </div>
  </div>
</template>

<script>
  import axios from '@/utilities/axios-global'
  import { mapState, mapActions } from 'vuex'
  import ReviewRequestAcuteRecordDetails from './ReviewRequestAcuteRecordDetails'
  import HiaAuthorization from '@/mixins/hiaAuthorization'

  export default {
    mixins: [HiaAuthorization],
    data: function () {
      return {
        activeStep: 0,
        loading: true,
        submitting: false,
        editLoading: false,
        recordLoading: false,
        dateRangeOptions: {
          disabledDate(time) {
            let today = new Date(Date.now() - (24 * 60 * 60 * 1000))
            return time.getTime() < today.getTime()
          }
        },
        rules: {
          location: [
            { required: true, message: 'Please Select a Location', trigger: 'change' }
          ],
          dateRangeDisplay: [
            { required: true, message: 'Please Select a Date Range', trigger: 'change' }
          ],
          reviewType: [
            { required: true, message: 'Please Select a Review Type', trigger: 'change' }
          ],
          reviewDescription: [
            { required: true, message: 'Please Input a Review Description', trigger: 'change' }
          ],
          acuteReviewTypeId: [
            { required: true, message: 'Please Input an Acute Review Type', trigger: 'none' }
          ],
          proReviewTypeId: [
            { required: true, message: 'Please Input a Pro Review Type', trigger: 'none' }
          ]
        }
      }
    },
    name: 'ReviweRequest',
    methods: {
      ...mapActions('requests/reviews', ['GET_REVIEWVALIDATIONS', 'GET_REVIEW_TYPES', 'GET_REVIEW_SCHEDULE_REQUEST', 'PUT_TOGGLE_PRO_SELECTED_BY', 'PUT_REVIEW_SCHEDULE_REQUEST_RECORDS', 'PUT_REVIEW_SCHEDULE_REQUEST', 'PUT_REVIEW_SCHEDULE_REQUEST_PRO_RECORDS', 'PUT_REVIEW_SCHEDULE_REQUEST_AMBULATORY_RECORDS', 'DELETE_REVIEW_SCHEDULE_REQUEST_RECORDS', 'DELETE_REVIEW_SCHEDULE_REQUEST_PRO_RECORDS', 'DELETE_REVIEW_SCHEDULE_REQUEST_AMBULATORY_RECORDS']),
      ...mapActions('requests/', ['GET_SPECIALTIES', 'GET_AMBULATORY_SPECIALTIES_LOOKUP']),
      handleRecordSaveError(error, reloadAfterError) {
        const message = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Unable to save review schedule request.'
        this.$message({
          type: 'error',
          message: message,
          duration: 5000
        })
        if (reloadAfterError) {
          this.initialize()
        }
      },
      initialize() {
        if (!this.nucleusUser()) {
          this.loading = false
          return
        }
        this.loading = true
        axios.all([this.GET_REVIEW_SCHEDULE_REQUEST(this.$route.params.id), this.GET_REVIEW_TYPES(), this.GET_REVIEWVALIDATIONS(), this.GET_SPECIALTIES(), this.GET_AMBULATORY_SPECIALTIES_LOOKUP()])
          .then(axios.spread(() => {
            this.$nextTick(() => {
              this.loading = false
            })
          }))
      },
      toggleProSelectedBy() {
        let payload = {
          requestId: this.$route.params.id,
          reviewRequest: this.reviewRequest
        }

        this.recordLoading = true
        this.PUT_TOGGLE_PRO_SELECTED_BY(payload).then(() => {
          this.recordLoading = false
          this.$message({
            message: 'Review Schedule Request Saved',
            type: 'success'
          })
        }).catch(error => {
          this.recordLoading = false
          this.handleRecordSaveError(error, true)
        })
      },
      editReviewRequest() {
        this.$refs['reviewRequest'].validate((valid) => {
          if (valid) {
            let payload = {
              requestId: this.$route.params.id,
              reviewRequest: this.reviewRequest
            }
            this.editLoading = true
            this.PUT_REVIEW_SCHEDULE_REQUEST(payload).then(() => {
              this.editLoading = false
              this.$message({
                message: 'Review Schedule Request Saved',
                type: 'success'
              })
            }, error => {
              let message = error.response.data ? error.response.data.message : error
              this.$message({
                type: 'error',
                message: message,
                duration: 5000
              })
              this.editLoading = false
            })
          }
        })
      },
      editRecords(payload) {
        this.recordLoading = true
        this.PUT_REVIEW_SCHEDULE_REQUEST_RECORDS(payload).then(() => {
          this.recordLoading = false
          this.$message({
            message: 'Review Schedule Request Saved',
            type: 'success'
          })
        }).catch(error => {
          this.recordLoading = false
          this.handleRecordSaveError(error, true)
        })
      },
      editProRecords(payload) {
        this.recordLoading = true
        this.PUT_REVIEW_SCHEDULE_REQUEST_PRO_RECORDS(payload).then(response => {
          this.recordLoading = false
          this.$message({
            message: 'Review Schedule Request Saved',
            type: 'success'
          })
        }).catch(error => {
          this.recordLoading = false
          this.handleRecordSaveError(error, true)
        })
      },
      clearRecords(payload) {
        this.recordLoading = true
        this.DELETE_REVIEW_SCHEDULE_REQUEST_RECORDS(payload).then(response => {
          this.recordLoading = false
          this.$message({
            message: 'Review Schedule Request Saved',
            type: 'success'
          })
        }).catch(error => {
          this.recordLoading = false
          this.handleRecordSaveError(error, true)
        })
      },
      clearProRecords(payload) {
        this.recordLoading = true
        this.DELETE_REVIEW_SCHEDULE_REQUEST_PRO_RECORDS(payload).then(response => {
          this.recordLoading = false
          this.$message({
            message: 'Review Schedule Request Saved',
            type: 'success'
          })
        }).catch(error => {
          this.recordLoading = false
          this.handleRecordSaveError(error, true)
        })
      },
      editAmbulatoryRecords(payload) {
        if (!payload || payload.requestId == null) {
          return
        }
        this.recordLoading = true
        this.PUT_REVIEW_SCHEDULE_REQUEST_AMBULATORY_RECORDS(payload).then(response => {
          this.recordLoading = false
          this.$message({
            message: 'Review Schedule Request Saved',
            type: 'success'
          })
        }).catch(error => {
          this.recordLoading = false
          this.handleRecordSaveError(error, true)
        })
      },
      clearAmbulatoryRecords(payload) {
        if (!payload || payload.requestId == null) {
          return
        }
        this.recordLoading = true
        this.DELETE_REVIEW_SCHEDULE_REQUEST_AMBULATORY_RECORDS(payload).then(response => {
          this.recordLoading = false
          this.$message({
            message: 'Review Schedule Request Saved',
            type: 'success'
          })
        }).catch(error => {
          this.recordLoading = false
          this.handleRecordSaveError(error, true)
        })
      }
    },
    created: function () {
      this.initialize()
    },
    computed: {
      ...mapState('user/', ['currentClient', 'currentClientId']),
      ...mapState('requests/reviews', ['reviewValidations', 'reviewRequest', 'reviewTypes'])
    },
    components: {
      ReviewRequestAcuteRecordDetails
    }
  }
</script>

<style scoped>
  /* FORM STYLE */
  .editForm>>>.reviewDescription,
  .editForm>>>.notes {
    width: 350px;
  }
</style>
